import {
    getAsync as _getAsync,
    addAsync as _addAsync,
} from "../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = (trnFlowTaskId) => `/flow-tasks/${trnFlowTaskId}/activity`;

function normalizeTaskData(data) {
    const { date: dateInMillis, entryData: entryDataString } = data;

    const date = dateInMillis && new Date(dateInMillis);
    const entryData = JSON.parse(entryDataString);

    return {
        ...data,
        date,
        dateString: dateToString(date),
        entryData,
    };
}

export function normalizeTasks(tasks) {
    return tasks.map((d) => normalizeTaskData(d));
}

export async function getAllByTaskAsync({ trnFlowTaskId }) {
    return _getAsync({
        url: `${BASE_URL(trnFlowTaskId)}/by-task`,
        normalizer: normalizeTasks,
    });
}

export async function addForTaskAsync({ trnFlowTaskId, payload }) {
    return _addAsync({ url: `${BASE_URL(trnFlowTaskId)}`, data: payload });
}
